var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.571 16L5.159 14.264H8.827L9.415 16H11.949L8.393 6.172H5.621L2.065 16H4.571ZM6.993 8.818L8.211 12.416H5.789L6.993 8.818Z",
    fill: "#00AEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.4H2",
    stroke: "#00AEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "white",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.205 10.96C20.7743 11.0813 21.2317 11.3637 21.577 11.807C21.9223 12.2503 22.095 12.7567 22.095 13.326C22.095 14.1473 21.808 14.7983 21.234 15.279C20.66 15.7597 19.8597 16 18.833 16H14.255V6.172H18.679C19.6777 6.172 20.4593 6.40066 21.024 6.858C21.5887 7.31533 21.871 7.936 21.871 8.72C21.871 9.29866 21.7193 9.77933 21.416 10.162C21.1127 10.5447 20.709 10.8107 20.205 10.96ZM16.649 10.148H18.217C18.609 10.148 18.91 10.0617 19.12 9.889C19.33 9.71633 19.435 9.462 19.435 9.126C19.435 8.79 19.33 8.53333 19.12 8.356C18.91 8.17866 18.609 8.09 18.217 8.09H16.649V10.148ZM19.344 13.795C19.1247 13.977 18.8143 14.068 18.413 14.068H16.649V11.898H18.385C18.7863 11.898 19.1013 11.996 19.33 12.192C19.5587 12.388 19.673 12.6587 19.673 13.004C19.673 13.3493 19.5633 13.613 19.344 13.795Z",
    fill: "#0973F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabGroup);
export default __webpack_public_path__ + "static/media/tabGroup.161ce797.svg";
export { ForwardRef as ReactComponent };